type ConversationMessage = {
  id: string;
  created_at?: string | null;
  user_id?: string | null;
  is_deleted?: boolean | null;
};

const toTimestamp = (value?: string | null) => {
  if (!value) {
    return 0;
  }

  const parsed = new Date(value).getTime();
  return Number.isFinite(parsed) ? parsed : 0;
};

export const getConversationReadCutoff = (
  joinedAt?: string | null,
  lastReadAt?: string | null,
) => Math.max(toTimestamp(joinedAt), toTimestamp(lastReadAt));

export const getFirstUnreadMessageId = (
  messages: ConversationMessage[],
  currentUserId?: string | null,
  joinedAt?: string | null,
  lastReadAt?: string | null,
) => {
  if (!currentUserId) {
    return null;
  }

  const cutoff = getConversationReadCutoff(joinedAt, lastReadAt);
  const firstUnread = messages.find(
    (message) =>
      !message.is_deleted
      && message.user_id !== currentUserId
      && toTimestamp(message.created_at) > cutoff,
  );

  return firstUnread?.id ?? null;
};
